import {AppRoutes} from "../utils/constants";

const HelperService = {
  getDayjs: function () {
    const dayjs = require('dayjs');
    const customParseFormat = require('dayjs/plugin/customParseFormat');
    dayjs.extend(customParseFormat);
    return dayjs;
  },
  getRandomAnimation: function (){
    const animations = [
      'fade',
      'fade-right',
      // 'zoom-in',
      // 'slide-right',
      // 'flip-right', // too crazy + screws layout
      // 'flip-left',
      // 'slide-left',
      // 'fade-left',
    ];
    return animations[Math.floor(Math.random() * animations.length)];
  },
  handleFormErrors: function (error, validationErrorsSetter){
    if( error.response && error.response.data && error.response.data.code && error.response.data.code===420 && validationErrorsSetter ){
      let err = {};
      for (const field in error.response.data.data){
        if (!err[field]){
          err[field] = [];
        }
        err[field] = [...err[field], ...error.response.data.data[field]];
      }
      validationErrorsSetter(err);
    }
  },
  handleApiErrors: function (error, onErrorCallback=null, defaultMessage="Nepodarilo sa získať odpoveď na vašu požiadavku."){
    let message = error.response && error.response.data && error.response.data.message ? error.response.data.message : defaultMessage;
    if( error.response && error.response.data && error.response.data.code && [401, 419].includes(error.response.data.code)){
      message = 'Platnosť vášho prihlásenia vypršala, preto sme vás museli odhlásiť. Pre pokračovanie sa prosím znovu prihláste.';
      window.location = AppRoutes.login.path;
    }
    if ('function'===typeof onErrorCallback){
      onErrorCallback(message);
    }
    console.log(error);
  },
  getObjByKey: function(list=[], key=null, val=null){
    if (!list || !list.length || !key || !val){
      return null;
    }
    let foundItem = null;
    list.filter((item)=>{
      if (item.hasOwnProperty(key) && item[key] == val){
        foundItem = item;
      }
      return item;
    })
    return foundItem;
  },
  getObjByMaxValueKey: function(list=[], key=null){
    if (!list || !list.length || !key){
      return null;
    }
    if (list.length===1){
      return list.pop();
    }
    return list.reduce(function(prev, current) {
        if (!prev.hasOwnProperty(key) || !current.hasOwnProperty(key)){
          throw new Error(`${key} not in the object - cant get max value`);
        }
      return (prev.value > current.value) ? prev : current;
    });
  },
  addOrReplaceItemInList: function(list=[], item=null, keyAttribute='id'){
    if (!item || !item.hasOwnProperty(keyAttribute)){
      return list;
    }
    let oldRowFound = false;
    let newRows = list.map((old)=>{
      if (old[keyAttribute] === item[keyAttribute]){
        oldRowFound = true;
        return item;
      }
      return old;
    })
    if (!oldRowFound){
      newRows.push(item);
    }
    return newRows;
  },
  removeItemFromList: function(list=[], item=null, keyAttribute='id'){
    if (!item || !item.hasOwnProperty(keyAttribute)){
      return list;
    }
    return list.filter((old)=>{
      if (old[keyAttribute] === item[keyAttribute]){
        return false;
      }
      return true;
    })
  },
  dateSortFunction: function(a, b, sortKey) {
    const dayjs = require('dayjs');
    if (!a.hasOwnProperty(sortKey) || !b.hasOwnProperty(sortKey)){
      return 0;
    }
    return dayjs(a[sortKey]) - dayjs(b[sortKey]);
  },
  simpleSortFunction: function(a, b, sortKey) {
    if (!a.hasOwnProperty(sortKey) || !b.hasOwnProperty(sortKey)){
      return 0;
    }
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  },
  formatDate: function(date, format="D. M. YYYY"){
    if (!date){
      return '';
    }
    const dayjs = require('dayjs');
    let newDate = dayjs(date).format(format);
    if (newDate){
      return newDate;
    }
    return date;
  },
  formatDateTime: function(date, format="D. M. YYYY, HH:MM"){
    const dayjs = require('dayjs');
    let newDate = dayjs(date).format(format);
    if (newDate){
      return newDate;
    }
    return date;
  },
  objectPrettyPrint: function(obj=null, level=0){
    if (!obj || typeof obj !== 'object') {
     return '';
    }
    let htmlString = '';
    let keys = Object.keys(obj);
    if (!keys || !keys.length){
      return '';
    }
    htmlString = keys.map((k)=>{
      if (obj && obj.hasOwnProperty(k) && obj[k] && typeof obj[k] == 'object') {
        return this.objectPrettyPrint(obj[k], level+1);
      }
      return `<div className="ps-${level}"><span>${k}</span>: <strong>${obj[k]}</strong></div>`
    }).join('');

    return <div dangerouslySetInnerHTML={{__html: htmlString}}></div>;
  },
  getRandomColor: function(date, format="D. M. YYYY, HH:MM"){
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  },
  getInitials : function(user){
    let initials;
    let name = `${user.first_name} ${user.last_name}`;
    const nameSplit = name.split(" ");
    const nameLength = nameSplit.length;
    if (nameLength > 1) {
      initials =
        nameSplit[0].substring(0, 1) +
        nameSplit[nameLength - 1].substring(0, 1);
    } else if (nameLength === 1) {
      initials = nameSplit[0].substring(0, 1);
    } else return;

    return initials.toUpperCase();
  },
  createImageFromInitials : function(size, name, color){
    if (name == null) return;

    const canvas=document.createElement('canvas')
    const context=canvas.getContext('2d')
    canvas.width=canvas.height=size

    context.fillStyle="#ffffff"
    context.fillRect(0,0,size,size)

    context.fillStyle=`${color}50`
    context.fillRect(0,0,size,size)

    context.fillStyle=color;
    context.textBaseline='middle'
    context.textAlign='center'
    context.font =`${size/2}px Nunito`
    context.fillText(name,(size/2),(size/2))

    return canvas.toDataURL()
  },
  generateKey: function(length = 6) {
    const chars = 'abcdefghijklmnopqrstuvwxyz1234567890';
    const rand = (min = 0, max = 1000) => Math.floor(Math.random() * (max - min) + min);
    const randchars = [];
    for (let i = 0; i < length; i++) {
      randchars.push(chars[rand(0, chars.length)]);
    }
    return randchars.join('');
  }
}

export default HelperService;

export function useHelperService() {
  return {
    getRandomAnimation: HelperService.getRandomAnimation,
    handleFormErrors: HelperService.handleFormErrors,
    addOrReplaceItemInList: HelperService.addOrReplaceItemInList,
    formatDate: HelperService.formatDate,
    formatDateTime: HelperService.formatDateTime,
    objectPrettyPrint: HelperService.objectPrettyPrint,
    getRandomColor: HelperService.getRandomColor,
    getInitials : HelperService.getInitials ,
    createImageFromInitials : HelperService.createImageFromInitials ,
    generateKey : HelperService.generateKey ,
    dateSortFunction : HelperService.dateSortFunction,
    getObjByKey : HelperService.getObjByKey,
    getObjByMaxValueKey : HelperService.getObjByMaxValueKey,
  };
}
